import React, {useRef}  from 'react'
import {  AppBar,Typography, Toolbar, Stack,Button,Box, Grid, Divider, Link } from '@mui/material'
import logo from '../res/logo/logow.webp'
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';




const Footer = ({home,about,gallery,services,otherServices,contact,terms, customers}) => {
  const theme = useTheme()
  const md_down = useMediaQuery(theme.breakpoints.down('md'));


  let scrollTo = (ref)=> {
    if (!ref.current) return;
    ref.current.scrollIntoView({ behavior: "smooth" });
  }
  return (
  //   <AppBar position="sticky" sx={{backgroundColor:'secondary.main',boxShadow:0,padding:0}}>
  //      <Toolbar sx={{display:'flex'}}>

  //        <Grid container>

  //          <Grid item xs={4}>
  //             <Typography variant="h5" fontSize={{xs:48,md:60}}>Footer</Typography>
  //          </Grid>

          
  //        </Grid>
       
            
            
        
       
  //      </Toolbar>
       
  //  </AppBar>
<Box flexDirection="column" sx={{background:"linear-gradient(to bottom, #f2e6d3,#f2e6d3,#d2a55a)"}}>

  <Grid container sx={{p:2,pt:4}}>
    <Grid container item xs={2}  alignItems='flex-start'>
      <Stack>
      <img src={logo} alt="D'Core"
      //  width={120} height={85}
      
      width={md_down?64:120} height={md_down?48:85} 
      />

      </Stack>
    </Grid>


    <Grid container item xs={8}  alignItems='space-between' justifyContent='center'  >
      
      {/* <Divider orientation='vertical' flexItem  sx={{backgroundColor:"secondary.main", borderRightWidth: 1, marginX:2}} /> */}
      
      <Stack width={0.9} justifyContent={{xs:'center',sm:'space-between'}} alignItems='flex-end'>
      {/* <Typography variant={md_down?'subtitle1':'h6'} color='primary.dark' align='center' sx={{width: 1}}>Sitemap</Typography> */}
      
      <Stack direction={{xs:'column', sm:'row'}}width={1} gap={{xs:0,md:8}} alignItems={{xs:'center',sm:'flex-start'}} justifyContent='space-evenly'>

        <Stack justifyContent='center'>
        {/* <Typography variant={md_down?'h6':'h5'} color='primary.dark' align='center' sx={{width: 1}}>Sitemap</Typography> */}
        <Typography variant={md_down?'subtitle2':'subtitle1'}  onClick={()=>{scrollTo(about)}}>About</Typography>
        <Typography variant={md_down?'subtitle2':'subtitle1'} onClick={()=>{scrollTo(gallery)}}>Gallery</Typography>
        <Typography variant={md_down?'subtitle2':'subtitle1'} onClick={()=>{scrollTo(services)}}>Featured Services</Typography>
        <Typography variant={md_down?'subtitle2':'subtitle1'} onClick={()=>{scrollTo(otherServices)}}>Other Services</Typography>
        
      </Stack>
      <Stack justifyContent='center'>
        
        <Typography variant={md_down?'subtitle2':'subtitle1'} onClick={()=>{scrollTo(customers)}}>Reviews</Typography>
        <Typography variant={md_down?'subtitle2':'subtitle1'} onClick={()=>{scrollTo(terms)}}>Terms of Condition</Typography>
        <Typography variant={md_down?'subtitle2':'subtitle1'} onClick={()=>{scrollTo(contact)}}>Contact</Typography>
        
      </Stack>
      </Stack>
      </Stack>
      
    </Grid>

    
    <Grid container item xs={2} alignItems='center'>
      {/* <Divider orientation='vertical' flexItem sx={{backgroundColor:"secondary.main", borderRightWidth: 1, marginX:2}} /> */}
      <Stack >
        <Link href='https://www.facebook.com/dcorepaperie/' target="_blank" rel="noopener">
          <FacebookIcon sx={{fontSize:32,color:'primary.dark'}}/>
          </Link>

          <Link href='https://www.instagram.com/dcorepaperie/' target="_blank" rel="noopener">
          <InstagramIcon sx={{fontSize:32,color:'primary.dark'}}/>
          </Link>
        
        
       
      </Stack>
    </Grid>
  </Grid>

  <Grid container justifyContent='center' sx={{padding:2}}> 
  <Grid  item xs={12} > 
  <Box sx={{display: 'flex', justifyContent:'center' ,flexDirection:{xs:'column',sm:'row'}}} >
    <Typography variant='subtitle1' align='center' color='secondary.dark'>
    {"© "}D'Core Paperie 
      
    </Typography>
    <Typography  display='inline' variant='subtitle1' align='center' sx={{marginLeft:1}}>
        <Link href='https://www.shanka.tech'  sx={{color:'white',textDecoration: 'underline'}}> 
         Created by Shanka
        </Link>
      </Typography>


      </Box>
  </Grid>

  </Grid>

</Box>
  
  )
}

export default Footer